<mat-card *ngIf="!updateMode">{{'add' | translate}}</mat-card>
<mat-card *ngIf="updateMode">{{'update' | translate}}</mat-card>

<div align="end" class="row" style="padding:10px 10px 0 0;">
    <!-- <span class="spacer"></span> -->

    <button mat-raised-button color="primary" (click)="submit()"
        [disabled]="otherInfo.info == null || otherInfo.info == '' || FName.invalid">
        <mat-icon>done</mat-icon>
        {{'submit' | translate}}
    </button>
    &nbsp;
    <button mat-raised-button (click)="back()">
        <mat-icon>keyboard_backspace</mat-icon>
        {{'back' | translate}}
    </button>
    &nbsp;
</div>

<mat-grid-list cols="5" rowHeight="100px">

    <mat-grid-tile colspan="4">
        <mat-form-field appearance="standard">
            <mat-label>{{'name' | translate}}</mat-label>
            <input matInput [(ngModel)]="otherInfo.name" required #FName="ngModel">
            <mat-error *ngIf="FName.invalid">{{'requiredField' | translate}}</mat-error>
        </mat-form-field>

    </mat-grid-tile>

    <mat-grid-tile>
        <mat-checkbox style="margin-right: 10px;" class="example-margin" [(ngModel)]="active">{{'active' | translate}}
        </mat-checkbox>
    </mat-grid-tile>

</mat-grid-list>


<div>
    <br />
</div>


<div [ngxSummernote]="config" [(summernoteModel)]="otherInfo.info"></div>


<!-- <mat-accordion class="example-headers-align" multi>
    <mat-expansion-panel>
        <mat-expansion-panel-header>
            <mat-panel-title>
                طريقة استخدام البطاقة
            </mat-panel-title>

        </mat-expansion-panel-header>
      
    </mat-expansion-panel>
</mat-accordion> -->